<template>
  <!-- 
    对于PC端，sidebar不受 isMobileSidebarVisible 影响，一直是普通布局；
    对于移动端，用 transform + 条件class 来控制是否可见。
  -->
  <div class="sidebar" :class="{
    'mobile-active': isMobileSidebarVisible
  }">
    <div class="avatar-section">
      <el-avatar icon="el-icon-user" :src="userData.avatar_url" size="medium" />
      <div>{{ userData.first_name }}</div>
    </div>
    <el-menu :default-active="$route.path" class="el-menu-vertical-demo" background-color="#ffffff" text-color="#303133"
      active-text-color="#409EFF" :router="true">

      <el-menu-item index="/user">
        <i class="el-icon-s-home"></i>
        <span slot="title">Personal Center</span>
      </el-menu-item>

      <!-- <el-menu-item index="/subscription">
        <i class="el-icon-notebook-2"></i>
        <span slot="title">Subscription</span>
      </el-menu-item> -->

      <el-menu-item index="/Indent">
        <i class="el-icon-money"></i>
        <span slot="title">Orders</span>
      </el-menu-item>

      <el-menu-item index="/curriculum">
        <i class="el-icon-notebook-1"></i>
        <span slot="title">Courses</span>
      </el-menu-item>
      <!-- 
      <el-menu-item index="/download">
        <i class="el-icon-setting"></i>
        <span slot="title">Download</span>
      </el-menu-item> -->

      <!-- New Address Menu Item -->
      <el-menu-item index="/address">
        <i class="el-icon-location"></i>
        <span slot="title">Address</span>
      </el-menu-item>

    </el-menu>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: "AppSidebar",
  props: {
    // 父组件传来的布尔值：移动端是否显示侧边栏
    isMobileSidebarVisible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters("user", ["userData"]),
  },
};
</script>

<style scoped>
.sidebar {
  width: 240px;
  background-color: #fff;
  border-right: 1px solid #ebeef5;
  min-height: 100vh;
  box-sizing: border-box;
  padding-top: 20px;
  overflow: auto;
}

.avatar-section {
  margin-bottom: 20px;
  text-align: center;
}

.el-menu-vertical-demo {
  width: 100%;
  border: none;
}


/* 
  移动端下：让 sidebar 变为“抽屉式”，默认为 transform: translateX(-100%) 隐藏在屏幕左边；
  当 .mobile-active 时，再 transform: translateX(0) 显示出来
*/
</style>